import styled from "styled-components";

export const StyledEvidenceConclusionWrapper = styled.div`
  background-color: white;
  margin: 1rem 0 0.375rem -1.125rem;
  position: relative;
`;
